import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonCard, IonCheckbox, IonContent, IonIcon, IonInput, IonItem, IonLabel, IonList, IonNote, IonPage, IonTitle } from "@ionic/react";
import { eye, eyeOff, lockClosed } from "ionicons/icons";
import { useRef, useState } from "react";
//import { AuthPending } from "../../auth/AuthContext";
//import DefaultProvider from "../../auth/DefaultProvider";
import { useIsMobile } from "../Responsive";
import loginStyle from './Login.module.scss';
import { validate } from "./helper";
import { PasswordValidation, UsernameValidation } from "./regEx";
import { ContainerProps, LoginProps, RegExpObject } from "./types";

import
{
    authContext
} from "@ews/react-auth-context";
import Icon from "@ews/react-icons";

import useAuth = authContext.useAuth;

const Container: React.FC<ContainerProps> = ({ children, style, className }) =>
{
    const mobileView = useIsMobile();

    return mobileView ? <>{children}</> : <section className={className} style={style}>{children}</section>;
};

export const getErrorText = (errorString: string) =>
{
    if (!errorString.includes('"body":') || !errorString.includes('"error":')) {
        return errorString;
    }
    const errorObj: Record<string, any> = JSON.parse(errorString);
    const { error } = errorObj.body;
    console.log(error);
    return error;
};

const Login: React.FC<LoginProps> = ({ inputColor, backCardColor = 'primary', headerColor = 'dark' }) =>
{
    const link = useRef<HTMLAnchorElement>(null);

    const mobileView = useIsMobile();
    const { translate: t } = useL10n();

    const { login } = useAuth();

    const usernameInputRef = useRef<HTMLIonInputElement>(null);
    const passwordInputRef = useRef<HTMLIonInputElement>(null);

    const [isUserValid, setIsUserValid] = useState<boolean | null>(null);
    const [isPasswordValid, setIsPasswordValid] = useState<boolean | null>(null);

    const [showPassword, setShowPassword] = useState(false);

    const [userError, setUserError] = useState('');

    const [passwordError, setPasswordError] = useState('');

    const [error, setError] = useState('');

    const [lockLoginButton, setLockLoginButton] = useState(true);

    if (isUserValid && isPasswordValid && lockLoginButton) setLockLoginButton(false);


    function validateInputValues()
    {
        if (error.length) setError('');

        const username = usernameInputRef.current!.value!.toString().trim();

        const password = passwordInputRef.current!.value!.toString().trim();

        if (username.length > 0) {
            const regexList = Object.keys(UsernameValidation);

            for (let key of regexList) {
                const { should, errorMsg, regex } = (UsernameValidation as Record<string, RegExpObject>)[key];

                const isValide = validate(username, regex, { should, errorMsg });

                /*    if (isValide instanceof Error) {
                       setUserError(isValide.message);
                       setIsUserValid(false);
                       if (!lockLoginButton) setLockLoginButton(true);
                       return;
                   }; */
            }
            setIsUserValid(true);
        }

        if (password.length > 0) {
            const regexList = Object.keys(PasswordValidation);

            for (let key of regexList) {
                const { should, errorMsg, regex } = (PasswordValidation as Record<string, RegExpObject>)[key];
                const isValide = validate(password, regex, { should, errorMsg });

                if (isValide instanceof Error) {
                    setPasswordError(isValide.message);
                    setIsPasswordValid(false);
                    if (!lockLoginButton) setLockLoginButton(true);
                    return;
                };

            }
            setIsPasswordValid(true);
        }
    }

    function redirect()
    {
        link.current?.click();
    }

    const loginWrapp = async (username: string, password: string) =>
    {

        try {

            const isAuthenticated = await login(username, password);
            //console.log(isAuthenticated);
            //const isAuthenticated = await DefaultProvider.login(username, password);
            //console.log(isAuthenticated);
            //if (isAuthenticated) redirect();
            setError("");
        } catch (e: any) {
            setError((e as Error).message);
        }
    };

    return <IonPage>
        <IonContent>

            <section
                className={`${loginStyle.card}`} />

            <section className={`${loginStyle.LoginArea} ${mobileView ? loginStyle.mobile : ''}`}>
                <IonCard
                    color={backCardColor}
                    style={{ opacity: .8 }}
                    className={`
                        ${loginStyle.pageCenter}
                        ${loginStyle[mobileView ? 'loginHeightMobile' : 'loginHeightDesktop']}
                        ${loginStyle[mobileView ? 'loginCardWidthMobile' : 'loginCardWidthDesktop']}`
                    }
                />
                <span
                    className={`
                        ${loginStyle.pageCenter}
                        ${loginStyle[mobileView ? 'loginHeightMobile' : 'loginHeightDesktop']}
                        ${loginStyle[mobileView ? 'loginCardWidthMobile' : 'loginCardWidthDesktop']}`
                    }
                >
                    <IonCard
                        color={headerColor}
                        className={`${loginStyle.loginHeader} ${loginStyle.center} ${mobileView ? loginStyle.mobilHeaderRadius : ''}`}
                    >
                        <span className={`${loginStyle.fit} ${loginStyle.center} ${loginStyle.logoContainer} ${loginStyle.flex}`}>
                            <IonTitle>login</IonTitle>
                            <img
                                className={loginStyle.logoPosition}
                                src="assets/img/logo.png"
                                alt="logo"
                                width={55}
                                height={55} />
                        </span>
                    </IonCard>

                    <Container
                        className={loginStyle.flex}
                    >
                        {mobileView ? null : <IonCard
                            className={`${loginStyle.imageCardContainer} ${loginStyle.imageCardContainerImage}`}
                        >
                        </IonCard>}

                        <Container
                            className={`${loginStyle.loginContainer}`}
                        >
                            <IonCard
                                color={inputColor}
                                className={`${loginStyle.center} ${loginStyle.loginCard} ${loginStyle.loginPaddingMobile} ${loginStyle[mobileView ? 'cardWithMobile' : 'cardWithDesktop']}`}
                            >
                                <IonList
                                    color={inputColor}
                                    className={`${loginStyle.loginList} ${loginStyle.pageCenter}`}
                                >
                                    <IonItem
                                        color={inputColor}
                                        lines='none'
                                        className={`${isUserValid && 'ion-valid'} ${isUserValid === false && 'ion-invalid'}`}
                                    >
                                        <IonLabel
                                            className={`${mobileView ? '' : loginStyle.labelSize}`}
                                            position="stacked"
                                        >
                                            <Icon className={loginStyle.icon} icon={"user"} />
                                            {t('TD_BENUTZERNAME')}
                                        </IonLabel>
                                        <IonInput
                                            className={mobileView ? '' : loginStyle.labelSize}
                                            type="text"
                                            ref={usernameInputRef}
                                            onIonChange={() => validateInputValues()}
                                        />

                                        <IonNote
                                            style={userError.length ? {} : { dislay: 'none' }}
                                            color={inputColor}
                                            slot="error">
                                            {userError}
                                        </IonNote>
                                    </IonItem>
                                    {/*   <IonItemDivider /> */}
                                    <IonItem
                                        color={inputColor}
                                        lines='none'
                                        className={`${isPasswordValid && 'ion-valid'} ${isPasswordValid === false && 'ion-invalid'}`}
                                    >
                                        <IonLabel
                                            className={mobileView ? '' : loginStyle.labelSize}
                                            position="stacked"
                                        >
                                            <Icon className={loginStyle.icon} icon={"lock_icon_locked"} />
                                            {/*  <IonIcon className={loginStyle.icon} icon={lockClosed} /> */}
                                            {t('COM_FACPMANAGEMENT_USER_FIELD_PASSWORD_LABEL')}
                                        </IonLabel>
                                        <IonInput
                                            className={mobileView ? '' : loginStyle.labelSize}
                                            type={showPassword ? "text" : 'password'}
                                            ref={passwordInputRef}
                                            onIonChange={() => validateInputValues()}
                                        />
                                        <IonIcon
                                            className={loginStyle.passwordShowIconPosition}
                                            slot="end" icon={showPassword ? eyeOff : eye}
                                            onClick={() => setShowPassword(!showPassword)}
                                        />

                                        <IonNote
                                            style={passwordError.length ? {} : { dislay: 'none' }}
                                            color={'danger'}
                                            slot="error">
                                            {passwordError}
                                        </IonNote>
                                    </IonItem>
                                </IonList>
                            </IonCard>

                            <IonCard
                                color={inputColor}
                                className={`${loginStyle.center} ${loginStyle[mobileView ? 'cardWithMobile' : 'cardWithDesktop']}`}
                            >
                                <div className={loginStyle.rememberMeContianer}>
                                    <IonItem
                                        color={inputColor}
                                        lines="none">

                                        <IonCheckbox
                                            slot="start"
                                            aria-label={t('COM_USERS_LOGIN_REMEMBER_ME')}
                                            labelPlacement="end"
                                            className={loginStyle.rememberMeButton}
                                            checked />

                                    </IonItem>
                                </div>
                                <div className={`${loginStyle.center} ${loginStyle.fit}`}>
                                </div>
                            </IonCard>
                            <IonCard
                                color={inputColor}
                                className={`${loginStyle.center} ${loginStyle.linkContainer} ${loginStyle[mobileView ? 'cardWithMobile' : 'cardWithDesktop']}`}
                            >
                                <div className={`${loginStyle.center} ${loginStyle.fit}`}>
                                    <a href="#">{t('COM_VIRTUEMART_ORDER_FORGOT_YOUR_PASSWORD')}</a>
                                    <a href="#">{t('[REACT_IMPRINT]')}</a>
                                    <a href="#">{t('[REACT_HELP]')}</a>
                                </div>
                            </IonCard>
                            <IonCard
                                color={lockLoginButton ? 'danger' : 'success'}
                                className={`${loginStyle.center}  ${loginStyle.buttonCard} ${loginStyle[mobileView ? 'cardWithMobile' : 'cardWithDesktop']}`}
                            >
                                {/* <AuthValid> */}
                                <IonButton
                                    expand="full"
                                    //style={lockLoginButton ? { display: 'none' } : {}}
                                    color={lockLoginButton ? 'danger' : 'success'}
                                    disabled={lockLoginButton}
                                    className={loginStyle.loginButton}
                                    onClick={() =>
                                    {
                                        const username: string = usernameInputRef.current!.value!.toString().trim();
                                        const password: string = passwordInputRef.current!.value!.toString().trim();
                                        login(username, password);
                                    }}
                                >
                                    {t('COM_LOGIN')}
                                </IonButton>
                                {/*  </AuthValid> */}
                            </IonCard>

                            <IonCard
                                color={'danger'}
                                className={`${loginStyle.center} ${loginStyle[mobileView ? 'cardWithMobile' : 'cardWithDesktop']} ${loginStyle.errorCard} ${error.length ? '' : loginStyle.buttonCardNone}`}
                            >
                                <div
                                    style={{ textAlign: 'center', padding: '10px 0' }}
                                >
                                    {getErrorText(error)}
                                </div>
                            </IonCard>

                        </Container>
                    </Container>
                </span>
            </section>
            <a ref={link} href="/" hidden></a>
        </IonContent>
        {/*   <AuthPending>
            Checking state ...
        </AuthPending> */}
    </IonPage >;
};

export default Login;
